import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/useAuth';
import { platformCommandService, platformReadService } from '@/modules/platform';

interface PlatformSettings {
  platform_name: string;
  platform_icon_url: string;
}

export function usePlatformSettings() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  const { data: settings, isLoading } = useQuery({
    queryKey: ['platform-settings'],
    queryFn: async () => {
      const data = await platformReadService.getSettings();

      const result: PlatformSettings = {
        platform_name: 'SportBook',
        platform_icon_url: '',
      };

      data.forEach((row) => {
        if (row.key === 'platform_name' && row.value) result.platform_name = row.value;
        if (row.key === 'platform_icon_url' && row.value) result.platform_icon_url = row.value;
      });

      return result;
    },
    staleTime: 5 * 60 * 1000,
  });

  const updateSetting = useMutation({
    mutationFn: async ({ key, value }: { key: string; value: string }) => {
      await platformCommandService.upsertPlatformSetting(key, value, {
        actorUserId: user?.id,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platform-settings'] });
    },
  });

  return {
    settings: settings ?? { platform_name: 'SportBook', platform_icon_url: '' },
    isLoading,
    updateSetting,
  };
}

